import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Button } from '../../../components/base';
import ContentTable from '../../../components/ContentTable/ContentTable.component';
import { PERSONAL_DISCONTINUANCE_TABLE_FIELDS } from '../../../constants/personnel.constant';

export default class Discontinuance extends PureComponent {
  constructor(props) {
    super(props);
    this.onClickAdd = this.onClickAdd.bind(this);
  }

  onClickAdd() {
    const { history } = this.props;
    history.push('/dashboard/personalia/surat/tambah-pemberhentian');
  }

  render() {
    const { handleGetDiscontinuance } = this.props;
    return (
      <div className="discontinuance">
        <Button
          title="Tambah Surat Pemberhentian"
          onClick={this.onClickAdd}
        />
        <div className="discontinuance__content">
          <ContentTable
            onSearchContent={handleGetDiscontinuance}
            tableFields={PERSONAL_DISCONTINUANCE_TABLE_FIELDS}
          />
        </div>
      </div>
    );
  }
}
Discontinuance.propTypes = {
  handleGetDiscontinuance: PropTypes.func,
  history: PropTypes.object.isRequired,
};
Discontinuance.defaultProps = {
  handleGetDiscontinuance: noop,
};
